export default __webpack_public_path__ + "static/media/adamite.6d147371.jpg";